enum MessengerPostChannel {
  BILLING = "BILLING",
  CARGO = "CARGO",
  RAILY = "RAILY",
  SHARED = "SHARED",
  TAXI = "TAXI",
  DRIVER = "DRIVER",
  MILEAGE_NOTES = "MILEAGE_NOTES",
  MILEAGE_PASSENGER = "MILEAGE_PASSENGER",
  DELEGATION_NOTES = "DELEGATION_NOTES",
}

export default MessengerPostChannel;
